import Iops_page from "./iops";

const Iops = () => {
  return (
    <div>
      <Iops></Iops>
    </div>
  );
};

export default Iops_page;
